export const ActionTypes = {
  SET_ACTIVE_LINK: "SET_ACTIVE_LINK",
  SET_IDENTITY_NAME: "SET_IDENTITY_NAME",
  SET_FIRST_LEVEL_ACTIVE_MENU: "SET_FIRST_LEVEL_ACTIVE_MENU",
  SET_AGENTS: "SET_AGENTS"
};